import { PaginationState, SortingState } from '@tanstack/react-table';
import { z } from 'zod';

export const PolicyTransactionSchema = z.object({
	id: z.number(),
	fileIngestionId: z.number(),
	policyNumber: z.string().nullable(),
	policyId: z.string().nullable(),
	transSummaryId: z.string().nullable().optional(),
	transactionDate: z.string().refine((val) => !isNaN(Date.parse(val))),
	riskState: z.string(),
	premium: z.number(),
	tax: z.number(),
	policyFee: z.number(),
	inspectionFee: z.number().nullable().optional(),
	status: z.string(),
	userNotes: z.string().nullable().optional(),
	notes: z.string().nullable().optional(),
});

export type PolicyTransaction = z.infer<typeof PolicyTransactionSchema>;

export const all = async (
	fileIngestionId: number,
	params: object
): Promise<{ data: PolicyTransaction[]; total: number }> => {
	try {
		let queryString = '';
		if (params) {
			const paramsAsString = JSON.stringify(params)
				.replace(/:/g, '=')
				.replace(/,/g, '&')
				.replace(/[{}"]/g, '');

			const searchParams = new URLSearchParams(paramsAsString);
			

			queryString = `?id=${fileIngestionId}&${searchParams.toString()}`;
		}

		const response = await fetch(`/NorthLightPolicy/Details${queryString}`);

		return await response.json();
	} catch (err) {
		return {
			data: [],
			total: 0,
		};
	}
};

export const update = async (
	policyTransaction: PolicyTransaction,
): Promise<boolean> => {
	const res = await fetch(`/NorthLightPolicy/Update`, {
		method: 'PATCH',
		body: JSON.stringify(policyTransaction),
		headers: {
			'Content-Type': 'application/json',
		},
	});
	return res.ok;
};

export const downloadPolicies = async (
	fileIngestionId: number,
): Promise<Blob> => {
	const response = await fetch(
		`/NorthLightPolicy/Export?id=${fileIngestionId}`,
		{
			method: 'GET',
		},
	);

	return await response.blob();
};
